import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setClerkTokenGetter } from '@/services/api';
import config from '@/config';

/**
 * Hook to initialize Clerk authentication integration with the API client.
 * This sets up the token getter function that the API client uses to include
 * JWT tokens in requests.
 */
export function useClerkAuth() {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    if (config.CLERK_PUBLISHABLE_KEY && isLoaded) {
      // Set up the token getter function for the API client
      setClerkTokenGetter(async () => {
        try {
          return await getToken();
        } catch (error) {
          console.error('Error getting Clerk token:', error);
          return null;
        }
      });
    }
  }, [getToken, isLoaded]);
}